// extracted by mini-css-extract-plugin
module.exports = {"button":"checkbox_button__2VQp-","button-CHECKED":"checkbox_button-CHECKED__233X5 checkbox_button__2VQp-"};